<div *ngIf="!validador">
<p>Subir Curso</p>


<select id="cursos" [(ngModel)]="cursoSelected">
    <option [ngValue]="curso" *ngFor="let curso of cursos">{{curso.titulo}}</option>
  </select>

<!-- <input type="file" name="AgregarVideo" (change)="handleArchivo($event)"> -->
<input type="text" name="link" id="" [(ngModel)]="linkASubir">
<button (click)="subir()">Subir</button>

</div>

<div *ngIf="validador">
  <button (click)="validador = !validador">Subir otro video</button>
</div>